import { telegramConnectMiddleware } from "@/middleware";
import TelegramConnectPage from "@/pages/telegram/TelegramConnect";
import { createFileRoute } from "@tanstack/react-router";

type TelegramConnectRouteSearch = {
	token?: string;
};

export const Route = createFileRoute("/telegram/connect")({
	component: RouteComponent,
	loaderDeps: ({ search }) => ({ token: search.token }),
	loader: ({ deps }) => telegramConnectMiddleware(deps.token),
	validateSearch: (
		search: Record<string, unknown>,
	): TelegramConnectRouteSearch => ({
		token:
			typeof search.token === "string" && search.token.trim().length > 0
				? search.token
				: undefined,
	}),
});

function RouteComponent() {
	const { token } = Route.useSearch();
	return <TelegramConnectPage token={token} />;
}
